import apiRequest from './apiRequest';

const getAllUsers = (token) => {
    const url = `/auth/all`;
    return apiRequest(url, 'GET', token);
};

const updateUser = (userId, data, token) => {
    const url = `/auth/user/${userId}`;
    return apiRequest(url, 'PUT', token, data);
};

const updateProfilePassword = (data, token) => {
    const url = '/auth/change-password';
    return apiRequest(url, 'PUT', token, data);
};
const updateUserPassword = (data, token) => {
    const url = '/auth/admin/reset-password';
    return apiRequest(url, 'PUT', token, data);
};

const deleteUser = (userId, token) => {
    const url = `/auth/user/${userId}`;
    return apiRequest(url, 'DELETE', token);
};

const addUser = (data, token) => {
    const url = '/auth/signup';
    return apiRequest(url, 'POST', token, data);
};

const addAccount = (data, token) => {
    const url = '/auth/addAccount';
    return apiRequest(url, 'POST', token, data);
};

const login = (credentials) => {
    const url = '/auth/login';
    return apiRequest(url, 'POST', null, credentials);
};

const logout = (token) => {
    const url = '/auth/logout';
    return apiRequest(url, 'GET', token);
};

const requestOTP = (data, token) => {
    const url = '/auth/request-otp';
    return apiRequest(url, 'POST', token, data);
};

const verifyOTP = (data, token) => {
    const url = '/auth/verify-otp';
    return apiRequest(url, 'POST', token, data);
};

const usersApi = {
    getAllUsers,
    updateUser,
    addUser,
    deleteUser,
    updateProfilePassword,
    addAccount,
    login,
    logout,
    requestOTP,
    verifyOTP,
    updateUserPassword
};

export default usersApi;
